const relative = new Intl.RelativeTimeFormat(undefined, { numeric: 'auto' });

/** "3 minutes ago" from an ISO timestamp, coarsening as the value ages. */
export function timeAgo(iso: string): string {
  const then = new Date(iso).getTime();
  if (!Number.isFinite(then)) return '';

  const seconds = Math.round((then - Date.now()) / 1000);
  const magnitude = Math.abs(seconds);

  if (magnitude < 45) return 'just now';
  if (magnitude < 3600) return relative.format(Math.round(seconds / 60), 'minute');
  if (magnitude < 86_400) return relative.format(Math.round(seconds / 3600), 'hour');
  return relative.format(Math.round(seconds / 86_400), 'day');
}
